import { render, staticRenderFns } from "./SkeletonPropertyLoader.vue?vue&type=template&id=0b441f1e&scoped=true&"
import script from "./SkeletonPropertyLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonPropertyLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonPropertyLoader.vue?vue&type=style&index=0&id=0b441f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b441f1e",
  null
  
)

export default component.exports